


// console.log = function() {}
// console.warn = function() {}
//const CURRENT_ENVIRONMENT = 'production';  // ENVIRONMENT
const CURRENT_ENVIRONMENT = 'stage';  // ENVIRONMENT
const DEVLOPEMNT_ENVIRONMENT_BASEPATH = '/intelli/intellibaby';
const PRODUCTION_ENVIRONMENT_BASEPATH = '/intelli/intellibaby/';  // ENVIRONMENT
//const PRODUCTION_ENVIRONMENT_BASEPATH = '/fit/fitjunior'; 
const currentPlatform = getPlatForm(); // get current platform
console.log("Current platform : ", currentPlatform);

// const isDeviceIOSandSafari = getDeviceIOSandSafari();
/**
 * To get URL PATH based on production/stage environment
 */
const getURL = () => {
  let url = DEVLOPEMNT_ENVIRONMENT_BASEPATH;
  if (CURRENT_ENVIRONMENT == "production") {
    url = PRODUCTION_ENVIRONMENT_BASEPATH;
  }

  // if (currentPlatform != "DesktopBrowser" && CURRENT_ENVIRONMENT == "production"){
  //   url = "/m" + url;
  // }

  return url;
}


module.exports = {
  kPlatFormCarvivalAPP: "CarnivalApp",
  kPlatFormMobileBrowser: "MobileBrowser",
  kPlatFormDesktopBrowser: "DesktopBrowser",
  NotificationObject:{},
  QUERY_STRING:getURLQueryString(),
  currentPlatForm:currentPlatform,
  HEADER_DETAILS: '',
  DEVICE_ID: '',
  UNAUTORIZED_ACCESS_ERROR_CODE: 401,
  FORBIDDEN_ERROR: 403,
  STATUS_SUCCESS: 200,
  STATUS_ERROR_IN_API: 999, //from catch block
  FTK: '',
  USER_ID: '',
  USER_GENDER: '',
  IS_LOGGED_IN: false,
  YOUNGEST_CHILD:{},
  SELECTED_CHILD:{},
  YOUNGEST_CHILD_DOB:{},
  CHILD_OBJECT: [],
  SELECTED_CHILD_ID:'',  //<-- define this and set on all screens where you access tested with harshita '03635c27-dad2-4804-953c-b73c08e44950'
  IOS_DEVICE_RESOLUTION: '',
  LASTANSWERED: 0,
  MAXWIDTH: 600,
  USER_NAME:'',
  IS_SUBSCRIBED : '',
  BASE_PATH : '/intellibaby/',
  BASE_DOMAIN: 'https://intelli.firstcry.com/intellibaby/',
  BASE_APIPATH : 'https://stagesummercampapis.fcintelli.tech/',
  EMAIL:'',
  PHONE:'',
  CHECKOUT_URL:'https://checkout.firstcry.com/cart?intellibaby=1',
  USER_SUBSCRIPTION:[],
  IS_CHILD_LINKED:false,
  DAYS_TO_ENDLEVEL:'',
  LEVELS_DATA:'',
  LINKED_CHILD_ID:'',
  ALL_API_INITIATED:false,
  PRE_FILTERS:[],
  WEEK:0,
  AGE_MONTH:0,
  HEIGHTEST_INDEX:0
};


function getURLQueryString(){
  let searchQuery="";
  if(currentPlatform==="CarnivalApp" && !window.location.search.match(/from=app/)){
    const symb = window.location.search.match(/[?]/) ? "&" : "?"
    searchQuery = window.location.search + `${symb}from=app`
  }else{
   searchQuery = typeof window!=="undefined" && window.location.search
  }
  return searchQuery;
}


function isMobileUserAgent() {
  if(typeof navigator !== 'undefined') {
  if (navigator.userAgent.includes('Firstcry iOS App') || navigator.userAgent.includes('Firstcry##Android')) {

    return true;
  } else {
    return false;
  }
}
return false;

}

function isMobileBrowser(){
  
var isMobile = /iPhone|iPad|iPod|Android/i.test(typeof navigator !== 'undefined'?navigator.userAgent:null);
if (isMobile) {
return true;
}
return false;
}

/**
 * To get device platform for url change append m or not
 */
function getPlatForm(){
  let platForm = "DesktopBrowser";
try{
  // if( Constant.currentPlatForm === "" || Constant.currentPlatForm === undefined)
  {
    if(isMobileUserAgent()){
      platForm = "CarnivalApp";
    }
    else if (isMobileBrowser() == true){
      platForm = "MobileBrowser";
    }
    else{
      platForm = "DesktopBrowser";
    }
    
  }
  return platForm;
}
catch(exception){
console.log("Constant js Exception",exception);
}

}